import { render, staticRenderFns } from "./ChatMessageArea.vue?vue&type=template&id=1a82e06b&scoped=true"
import script from "./ChatMessageArea.vue?vue&type=script&lang=js"
export * from "./ChatMessageArea.vue?vue&type=script&lang=js"
import style0 from "./ChatMessageArea.vue?vue&type=style&index=0&id=1a82e06b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a82e06b",
  null
  
)

export default component.exports